// extracted by mini-css-extract-plugin
export default {"root":"RightBarContent_root__qDkIe","placeHolderShimmer":"RightBarContent_placeHolderShimmer__LWOX+"};